import React from "react"
export function Hotels(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M1.25 3c.69 0 1.25.56 1.25 1.25V12H20v5h-2.5v-2.5h-15V17H0V4.25C0 3.56.56 3 1.25 3zM19 6a1 1 0 011 1v4H5a1 1 0 010-2h3V7a1 1 0 011-1h10zM5.503 4.5a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5z"
        fill="currentColor"
        id="prefix__hotels"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
